import _ from "lodash";
export default class notificationsController {
    static addNotification(id, type, content, shown, userId) {
        const notificationsString = localStorage.getItem("notifications" + userId);
        let notifications = [];
        if (notificationsString) {
            notifications = JSON.parse(notificationsString);
        }
        notifications.push({ id, type, content, shown, date: new Date() });
        notifications = _.takeRight(notifications, 30);
        localStorage.setItem("notifications" + userId, JSON.stringify(notifications));
    }
    static markNotificationsAsRead(userId) {
        const notificationsString = localStorage.getItem("notifications" + userId);
        if (notificationsString) {
            const notifications = JSON.parse(notificationsString);
            for (const notification of notifications) {
                notification.shown = true;
            }
            localStorage.setItem("notifications" + userId, JSON.stringify(notifications));
        }
    }
    static markNotificationAsRead(userId, id) {
        const notificationsString = localStorage.getItem("notifications" + userId);
        if (notificationsString) {
            const notifications = JSON.parse(notificationsString);
            const index = _.findIndex(notifications, { id });
            if (index >= 0) {
                notifications[index].shown = true;
            }
            localStorage.setItem("notifications" + userId, JSON.stringify(notifications));
        }
    }
    static getNotifications(userId) {
        const notificationsString = localStorage.getItem("notifications" + userId);
        return JSON.parse(notificationsString);
    }
}
